module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/id_kyushu-fd94242c74b2cdd5375a9d04eb671fb1.jpg";